import t from 'tcomb';

const TripGoal = t.enums.of([
  'BuildOrderRoute',
  'ReducerRoute'
], 'TripGoal');


module.exports = TripGoal;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/TripGoal.js
 **/